import axios from 'axios';
import snackBarService from '@/shared/snackbar/snackbar.service';
import Event from './event.entity';

export default class EventService {
  searchAllEvents(idEvent: string): Promise<Event> {
    return axios
      .get(`/events/${idEvent}/all-tree`)
      .then((response: any) => Event.of(response.data))
      .catch((err: any) => snackBarService.errorMessage(err.response.data.messages));
  }
}
